<!--登录-->
<template>
  <div class="login-container1">
    <div class="content-container">
      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="loginRules"
        class="login-form"
        label-position="right"
        label-width="80px"
      >
        <div class="login-header-cut" @click="loginCut">
          <div>
            {{ loginWay == "验证码" ? "帐号密码登录>" : "短信快捷登录>" }}
          </div>
        </div>
        <div class="title-container">
          <h3 class="title">DataBank Login</h3>
          <h5 class="sub-title">资料库 登录</h5>
        </div>

        <el-form-item
          prop="username"
          label="账号"
          :hide-required-asterisk="false"
        >
          <el-input
            ref="username"
            v-model="loginForm.username"
            placeholder="请输入手机号"
            name="username"
            @input="input"
            @blur="blur"
            :maxlengt="11"
            max="11"
          />
        </el-form-item>

        <el-form-item
          prop="password"
          label="密码"
          v-if="loginWay == '手机号' && loginWayType != 1"
        >
          <div class="verification-box">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              type="password"
              placeholder="请输入密码"
              name="password"
              tabindex="2"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
            />
          </div>
        </el-form-item>

        <el-form-item
          prop="password"
          label="验证码"
          v-if="loginWay == '验证码'"
        >
          <div class="verification-box">
            <el-input
              :key="passwordType"
              ref="password"
              v-model="loginForm.password"
              :type="passwordType"
              placeholder="请输入验证码"
              name="password"
              tabindex="2"
              auto-complete="on"
              @keyup.enter.native="handleLogin"
              style="width: 470px"
            />

            <!--发送验证码按钮-->
            <el-button type="primary" @click="sendCode" :disabled="draw">
              {{ content }}
            </el-button>
          </div>

          <!-- <span class="show-pwd" @click="showPwd" style="width: 20px">
            <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
          </span> -->
        </el-form-item>
        <el-form>
          <div class="login-box">
            <el-button
              :loading="loading"
              type="primary"
              style="width: 150px; height: 50px; margin-top: 50px"
              @click="handleLogin"
            >
              登 录
            </el-button>
          </div>
        </el-form>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validUsername } from "@/utils/validate";
import { getCode, login, loginType, tokenLogin } from "@/api/user";
export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!validUsername(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (this.loginWay == "验证码") {
        if (value.length < 6) {
          callback(new Error("验证码不能少于6位"));
        } else {
          callback();
        }
        return;
      }
      if (value.match(/^\s*$/)) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      // 登录方式 1 == 必须验证码登录 0 == 必须手机号 2 验证码/手机号
      loginWay: "手机号",
      content: "发送验证码",
      totalTime: 30, //倒计时
      canClick: true, //添加canClick
      draw: false,
      loginForm: {
        username: "",
        password: "",
      },
      loginRules: {
        username: [
          { required: false, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: false, trigger: "blur", validator: validatePassword },
        ],
      },
      loading: false,
      passwordType: "text",
      redirect: undefined,
      loginWayType: 0,
    };
  },
  created(){
    let phone = this.getUrlKey("phone")
    let token = this.getUrlKey("token")
    if(phone && token) {
      tokenLogin({phone,token})
        .then((resp) => {
          if (resp.code == 200) {
            // this.$message({
            //   message: resp.msg,
            //   type: "success",
            //   duration: 5 * 1000,
            // });
            this.loading = false;
            // this.$setCookie("token", resp.data, 30);
            localStorage.setItem("token", resp.data);
            // this.$store.dispatch('aiclass/user/saveOrgans', resp.data.organs)
            this.$router.push("/");
            return;
          } else {
            this.loading = false;
            this.$message({
              message: resp.msg,
              type: "warning",
              duration: 5 * 1000,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    getUrlKey(name){
      let res = new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href)
      if(res && res.length >= 1) {
        return res[1]
      }
      return undefined
      // return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [""])[1].replace(/\+/g, '%20')) || null
    },
    // 切换登录方式
    loginCut() {
      this.loginForm.password = "";
      if (this.loginWayType == 1) {
        this.$message.error("输入密码错误多次不能使用密码登录");
        return;
      }
      this.loginWay = this.loginWay == "验证码" ? "手机号" : "验证码";
    },
    // 检测账号登录方式
    async loginType(phone) {
      this.loginForm.password = "";
      var data = await loginType({
        phone: phone,
      });
      if (data.code == 200) {
        if (data.data.data) {
          this.loginWayType = data.data.data.type;
        }
      }
      //
      if (this.loginWay == "手机号") {
        if (this.loginWayType == 1) {
          this.$message.error("密码输入错误多次自动跳转验证码登录");
          this.loginWay = "验证码";
        }
      }
    },
    // 输入账号离开聚焦检测账号
    blur() {
      if (this.loginForm.username.length == 11) {
        this.loginType(this.loginForm.username);
      }
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          let type = this.loginWay == "验证码" ? 1 : 0;
          let param = {
            phone: this.loginForm.username,
            code: this.loginForm.password,
            type,
          };
          if (this.loginWay == "手机号") {
            param.password = this.loginForm.password;
            delete param.code;
            this.loginType(this.loginForm.username);
          }

          login(param)
            .then((resp) => {
              if (resp.code == 200) {
                this.$message({
                  message: resp.msg,
                  type: "success",
                  duration: 5 * 1000,
                });
                this.loading = false;
                // this.$setCookie("token", resp.data, 30);
                localStorage.setItem("token", resp.data);
                // this.$store.dispatch('aiclass/user/saveOrgans', resp.data.organs)
                this.$router.push("/");
                return;
              } else {
                this.loading = false;
                this.$message({
                  message: resp.msg,
                  type: "warning",
                  duration: 5 * 1000,
                });
              }
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    input() {
      this.loginForm.username = this.loginForm.username.replace(/[^0-9]/g, "");
    },
    //用户登录
    getData() {
      // userlogin().then((res) => {
      //   this.userlogin = res
      // })
    },
    //获取验证码
    getCode() {
      // this.loading = true;
      getCode({ phone: this.loginForm.username }).then((res) => {
        if (res.code == 200) {
          
          // this.loginForm.password = res.message;
        } else {
          this.$message({
            message: res.msg,
            type: "warning",
            duration: 5 * 1000,
          });
        }
      });
    },
    //获取验证码
    sendCode(canClick) {
      if (!canClick) {
        return;
      } //节流
      // if(!this.loading){
      //   return
      // }
      this.getCode();
      this.canClick = false;
      this.draw = true;
      this.content = this.totalTime + "s后重新发送";
      let clock = window.setInterval(() => {
        this.totalTime--;
        this.content = this.totalTime + "s后重新发送";
        if (this.totalTime < 0) {
          //当倒计时小于0时清除定时器
          window.clearInterval(clock); //关闭
          this.content = "重新发送验证码";
          this.totalTime = 30;
          this.canClick = true; //这里重新开启
          this.draw = false;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$cursor: #333; //输入颜色
$placeholder: #747474; //占位文本

/* reset element-ui css */
.login-container {
  min-width: 800px;
  min-height: 600px;
  display: flex;
}
</style>




<style lang="scss" scoped>
$bg: #021859;
$dark_gray: #747474;
$btn: #225493;
$btn_hover: #3d6494;
$btn_click: #1d4a80;

.login-container1 {
  width: 100%;
  height: 100%;
  /*background-color: $bg;*/
  background-image: url(../assets/login_bg.png);
  background-size: 100% 100%;
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  .login-header-cut {
    display: flex;
    justify-content: flex-end;
    font-size: 17px;
    color: #09aaff;
    cursor: pointer;
  }
  .login-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .verification-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content-container {
    width: 850px;
    height: 500px;
    max-width: 100%;
    max-height: 100%;
    display: flex;
  }

  .form-title {
    color: white;
    font-size: 36px;
  }
  /*登录表单*/
  .login-form {
    position: relative;
    width: 100%;
    padding: 60px;
    overflow: hidden;
    background-color: white;
  }

  .el-button {
    font-size: 18px;
    border-radius: 0;
    background: rgb(22, 155, 213);
    &:hover {
      background: rgb(39, 172, 230);
    }
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;
    margin-bottom: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .title {
      font-size: 40px;
      margin: 0px auto 10px auto;
      font-weight: 400;
      font-family: Arial;
    }
    .sub-title {
      font-size: 22px;
      color: #333;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
.login-container .el-form-item {
  border: none;
}

.login-container .el-input {
  width: 100%;
}
</style>


<style  scoped>
/* .content-container  /deep/  .el-input__inner{
    border-color: #c0c4cc;
} */
</style>